import { asyncRoutes, constantRoutes } from '@/router'
import { queryByUser } from '@/api/user'
/**
 * Use meta.role to determine if the current user has permission
 * @param route
 */
function hasPermission(routes, route) {
  if (route.meta && route.meta.perm) {
    return routes.some(resource => route.meta.perm === resource.resourceCode)
    // return routes.some(resource => route.meta.perm.includes(resource.resourceCode))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, resourceList) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(resourceList, tmp)) {
      if (tmp.children) {
        const findItem = tmp.children.find((item) => hasPermission(resourceList, item))
        if (tmp.redirect && findItem) {
          const pathArr = tmp.redirect.split('/')
          tmp.redirect = `/${pathArr[1]}/${(findItem && findItem.path) || ''}`
          if (findItem.children && findItem.children.length > 0) {
            const subItem = findItem.children.find((item) => hasPermission(resourceList, item))
            tmp.redirect = `/${pathArr[1]}/${(findItem && findItem.path) || ''}/${(subItem && subItem.path) || ''}`
          }
        } else {
          tmp.redirect = ''
        }
        tmp.children = filterAsyncRoutes(tmp.children, resourceList)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  resourceList: [],
  routes: [],
  addRoutes: [],
  childrenRoutes: [],
  checkPermission: false,
  accessedRoutes: [],
  roleList: []
}

const mutations = {
  SET_CEHCK_PERMISSION: (state, checkPermission) => {
    state.checkPermission = checkPermission
  },
  SET_DYNAMIC_ROUTES: (state, routes) => {
    state.routes = routes
  },
  SET_RESOURCE_LIST: (state, resourceList) => {
    state.resourceList = resourceList
  },
  SET_CHILDREN_ROUTES: (state, routes) => {
    state.childrenRoutes = routes
  },
  SET_ACCESSED_ROUTES: (state, routes) => {
    state.accessedRoutes = routes
  },
  SET_ROLE_LIST: (state, roleList) => {
    state.roleList = roleList
  }
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      let accessedRoutes
      if (roles.includes('admin')) {
        accessedRoutes = asyncRoutes || []
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
      }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
  queryResourceByUser({ commit }, data) {
    return new Promise(resolve => {
      queryByUser(data).then(res => {
        try {
          commit('SET_RESOURCE_LIST', res.data.resourceList)
          const accessedRoutes = filterAsyncRoutes(asyncRoutes, res.data.resourceList)
          const resultRoutes = constantRoutes.concat(accessedRoutes)
          commit('SET_CEHCK_PERMISSION', true)
          commit('SET_DYNAMIC_ROUTES', resultRoutes)
          commit('SET_ACCESSED_ROUTES', accessedRoutes)
          commit('SET_ROLE_LIST', res.data.roleList)
          resolve(accessedRoutes)
        } catch (error) {
          console.log(error)
        }
      }).catch(res => {

      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
